/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { ImageGalleryFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { ImageGalleryFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { getCliplisterFragmentedData } from '../Cliplister/mockdata';

export const imageGalleryDataMock: ImageGalleryFragmentFragment = {
  ...getCliplisterFragmentedData(),
  name: 'Nike Sportswear Sneaker »Air Max Ltd 3«',
  media: [
    {
      url: 'https://bilder.baur.de/i/empiriecom/178bbb3e07613a99de2a7ec2c059149d.jpg',
      type: 'IMAGE',
    },
    {
      url: 'https://bilder.baur.de/i/empiriecom/95b13cf1410e06890df051954cb2a760.jpg',
      type: 'IMAGE',
    },
    { url: 'https://bilder.baur.de/i/empiriecom/dec018c450db1eba702a543673ceec36', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/383d0a7b4b9b16ea24c15b67c285d360', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/0700ae8c2be9eea27539c9ac360f8e4a', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/9089977f7f3ee642203f73d41cdd6809', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/461c80ce868d3ad95b144b0d352c0bfd', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/a349067b824ce849d65c723e1002f985', type: 'IMAGE' },
    { url: 'https://bilder.baur.de/i/empiriecom/b9e01586579bd854d61abb4617076142', type: 'IMAGE' },
  ],
  additionalFlags: [
    { type: 'NEUTRAL', text: 'Im Korb', src: '' },
    { type: 'NEUTRAL', text: 'Neu', src: '' },
    {
      type: 'CUSTOM',
      text: '',
      src: 'https://bilder.baur.de/i/empiriecom/layer/baurde/wochen-highlights_neu_05122022',
    },
  ],
};

export function getImageGalleryFragmentedData(data?: ImageGalleryFragmentFragment) {
  return makeFragmentData(data || imageGalleryDataMock, ImageGalleryFragmentFragmentDoc);
}
